module.exports = __webpack_public_path__ + "static/img/alfamart.7830714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alfamart.png
// module id = abdO
// module chunks = 1